import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'store/hooks';
import styles from './result.module.scss';
import { PdfCollateral } from 'components/pdf-collateral';
import ResultSection from '../scoring/result-section';
import { toast } from 'react-toastify';

const ResultCollateral = () => {
  const contextApplication = useSelector((state) => state.applicationCollateral);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (contextApplication.data?.is_approved === null) navigate('/');
  }, [contextApplication, navigate]);

  React.useEffect(() => {
    if (!contextApplication.pending && !contextApplication.data) {
      toast.error('Заявка с такими данными не найдена');
      navigate('/collateral');
    }
  }, [contextApplication]);

  return (
    <div className={styles.result}>
      <div className={styles.content}>
        <div className={styles.pdf}>
          <PdfCollateral contextApplication={contextApplication} />
        </div>
        {contextApplication.data?.scoring_gold_log?.shap_link && (
          <div className={styles.shap_value}>
            <div className={styles.shap_value_title}>Значения Шэпли для принятия решений</div>
            <iframe
              title="shap_link"
              src={contextApplication.data?.scoring_gold_log?.shap_link}
              style={{ width: '100%' }}
            />
            {/* <div className={styles.gpt_text}>
              {contextApplication?.data?.scoring_gold_log.gpt_explanation && (
                <TypewriterText
                  text={contextApplication?.data?.scoring_gold_log.gpt_explanation}
                  id={contextApplication?.data?.id}
                  speed={30}
                />
              )}
            </div> */}
          </div>
        )}
      </div>
      <ResultSection contextApplication={contextApplication} pending={false} result={true} />
    </div>
  );
};

export default ResultCollateral;
